import httpClient from "./httpClient";
import { getApiBaseUrl } from "../data/authStorage";

const profileUrl = () => `${getApiBaseUrl()}/organizations/profile`;

export const getOrganizationProfile = async () => {
  const response = await httpClient.get(profileUrl());
  return response.data;
};
export const getOrganizationFeatureAccess = async () => (await httpClient.get(`${getApiBaseUrl()}/organizations/features/available`)).data;
export const updateOrganizationPlan = async (planKey, billingCycle = "MONTHLY") => (await httpClient.patch(`${getApiBaseUrl()}/organizations/plan`, { planKey, billingCycle })).data;
export const getSubscriptionInvoices = async () => (await httpClient.get(`${getApiBaseUrl()}/organizations/subscription/invoices`)).data;
export const updateBillingDetails = async (values) => (await httpClient.patch(`${getApiBaseUrl()}/organizations/subscription/billing-details`, values)).data;
export const cancelOrganizationSubscription = async (reason) => (await httpClient.post(`${getApiBaseUrl()}/organizations/subscription/cancel`, { reason })).data;

export const updateOrganizationProfile = async (values, logoFile) => {
  const formData = new FormData();
  Object.entries(values).forEach(([key, value]) => formData.append(key, Array.isArray(value) ? JSON.stringify(value) : value ?? ""));
  if (logoFile) formData.append("logo", logoFile);

  // Let the browser add the multipart boundary for FormData requests.
  const response = await httpClient.patch(profileUrl(), formData);
  return response.data;
};

export const requestOrganizationDeletionCode = async () => {
  const response = await httpClient.post(`${profileUrl()}/deletion-code`);
  return response.data;
};

export const deleteOrganizationAccount = async (code) => {
  const response = await httpClient.delete(profileUrl(), { data: { code } });
  return response.data;
};

export const exportOrganizationData = async () => {
  const response = await httpClient.get(`${profileUrl()}/data-export`);
  return response.data;
};
